<template>
  <div class="welfare-content">
    <div class="welfare-page">
      <img
        src="../../assets/yz/newWelfare/xrfl_title.webp"
        alt=""
        class="welfare-img"
      />

      <div class="coupon-block">
        <img
          src="../../assets/yz/newWelfare/xrfl_coupon.webp"
          alt=""
          class="welfare-img"
        />
        <img
          src="../../assets/yz/newWelfare/xrfl_get_btn.webp"
          alt=""
          class="receive-btn"
          @click="getNewWelfare"
        />
      </div>

      <img
        src="../../assets/yz/newWelfare/xrfl_more_coupon.webp"
        alt=""
        class="welfare-img"
      />
      <img
        src="../../assets/yz/newWelfare/xrfl_rule.webp"
        alt=""
        class="welfare-img"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive } from "vue";
import { getNewUserCoupon } from "@/api/yzgame.js";
import { setToken } from "@/utils/auth";
import { getQueryString } from "../../utils/location";
import { Toast } from "vant";

const state = reactive({
  uid: "",
});

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
});

//领取新人福利优惠券
const getNewWelfare = async () => {
  // 领取新人福利
  getNewUserCoupon({ uid: state.uid }).then((res) => {
    // console.log("领取新人福利返回的数据-------------", res);
    if (res.data.code == 1) {
      Toast("领取成功");
    } else {
      Toast(res.data.msg);
    }
  });
};
</script>

<style scoped>
.welfare-content {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: #9bd8ff;
}

.welfare-page {
  width: 100%;
  max-width: 750px;
  min-height: 100%;
  margin: 0 auto;
  padding-bottom: 40px;
  background: linear-gradient(180deg, #73c3ff 0%, #dff4ff 52%, #7dc7ff 100%);
}

.welfare-img {
  display: block;
  width: 100%;
  height: auto;
}

.coupon-block {
  position: relative;
  width: 100%;
}

.receive-btn {
  position: absolute;
  left: 50%;
  bottom: 8%;
  display: block;
  width: 72%;
  height: auto;
  transform: translateX(-50%);
  animation: welfareBtnScale 1s ease-in-out infinite;
  transform-origin: center center;
  touch-action: manipulation;
}

@keyframes welfareBtnScale {
  0%,
  100% {
    transform: translateX(-50%) scale(1);
  }

  50% {
    transform: translateX(-50%) scale(0.94);
  }
}
</style>
